module.exports = __webpack_public_path__ + "assets/img/Logo-UP.288417ad.png";